import { makeStyles } from '@material-ui/core'
import { TEST_ID_CASHFLOW_NAV_LINK } from 'e2e/playwrightTestIds'
import useNavigationLinks from 'layout/hooks/useNavigationLinks'
import React from 'react'
import { OpenSolarThemeType } from 'Themes'
import StyledNavLink from './StyledNavLink'

const useStyles = makeStyles((theme: OpenSolarThemeType) => ({
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
}))

interface PropTypes {
  layout: number
}

const Navigation: React.FC<PropTypes> = ({ layout }) => {
  const classes = useStyles()
  const navigationLinks = useNavigationLinks()

  return (
    <div className={classes.linkWrapper}>
      {layout >= 2 &&
        navigationLinks.map(({ badgeSeverity, label, key, uiKey, value }) => (
          <StyledNavLink
            badgeSeverity={badgeSeverity}
            key={key}
            label={label}
            layout={layout}
            to={`/${key}`}
            uiKey={uiKey}
            value={value}
            data-testid={key === 'cashflow' ? TEST_ID_CASHFLOW_NAV_LINK : undefined}
          />
        ))}
    </div>
  )
}
export default Navigation
